import { render } from "./OrdersShowCardPayment.vue?vue&type=template&id=dc4c060a"
import script from "./OrdersShowCardPayment.vue?vue&type=script&lang=js"
export * from "./OrdersShowCardPayment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__